import { TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineOppositeContent, TimelineSeparator } from "@mui/lab";
import { StatusChangeTimeLineEntity } from "../../common/Interfaces"
import styles from "./StatusChangeTimeLine.module.scss";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { getDateInYYYYMMDDHHmmss } from "../../common/Utils";

type Props = {
    statusChange: StatusChangeTimeLineEntity;
}

export default function StatusChangeTimeLineItem ({statusChange}: Props) {
    const {t} = useTranslation();

    const getDate = () => {
        if (statusChange.isLiteralDate){
            return statusChange.isInitialStatusChange ? 
            statusChange.event?.CreationDate ?? '' : 
            statusChange.statusChange.ChangeDate;
        }
        
        const statusDate = new Date(
            statusChange.isInitialStatusChange ? 
                        statusChange.event?.CreationDate ?? '' : 
                        statusChange.statusChange.ChangeDate
            );
            
        return getDateInYYYYMMDDHHmmss(statusDate);
    }

    return (<TimelineItem className={styles.fullWidth}>
        <TimelineOppositeContent style={{display: 'none'}}/>
        <TimelineSeparator key={`${statusChange.statusChange.Id}-separator`}>
            <TimelineDot
            key={`${statusChange.statusChange.Id}-dot`}
            sx={{
                bgcolor: statusChange.isInitialStatusChange
                ? statusChange.statusChange?.InitialStatus?.BackgroundColor
                : statusChange.statusChange?.FinalStatus?.BackgroundColor,
            }}
            />
            <TimelineConnector />
        </TimelineSeparator>

      <TimelineContent key={`${statusChange.statusChange.Id}-content`} 
        style={{
            borderRadius: '10px',
            margin: '10px',
            minWidth: '200px',
            background: statusChange.isInitialStatusChange
            ? statusChange.statusChange?.InitialStatus?.BackgroundColor
            : statusChange.statusChange?.FinalStatus?.BackgroundColor,
            color: statusChange.isInitialStatusChange
            ? statusChange.statusChange?.InitialStatus?.ForegroundColor
            : statusChange.statusChange?.FinalStatus?.ForegroundColor,
        }}>
          <Box className="flex-col w-full -mt-2 border-gray-300 border-2 rounded-xl items-center content-center justify-center">
            <Box className={styles.container}>
                <Typography className={styles.titleText}>
                    <b>
                    {`${
                        statusChange.isInitialStatusChange
                        ? statusChange.statusChange?.InitialStatus?.Name
                        : statusChange.statusChange?.FinalStatus?.Name
                    } (${getDate()})`}
                    </b>
                </Typography>

                <Typography className={styles.subtitleText}>
                    {`${t("REPORTEDBY")}: ${statusChange.isInitialStatusChange ? 
                                        statusChange.event.CreatedBy : 
                                        statusChange.statusChange.CreatedBy} ${statusChange.statusChange.IsManual > 0 ? 
                                        `(${t("EXECUTEDMANUALLY")})` : 
                                        ''}`
                    }
                </Typography>
            </Box>
          </Box>

        { statusChange.statusChange.Observation && statusChange.statusChange.Observation.length > 0 && (<Box>
            <hr
            style={{
            borderTop: `1px solid ${
                statusChange.isInitialStatusChange
                ? statusChange.statusChange?.InitialStatus?.ForegroundColor
                : statusChange.statusChange?.FinalStatus?.ForegroundColor
            }`,
            }}/>
        
            <Box className={styles.horizontalContainer}>
                <Typography className={styles.titleText}>
                    <b>{`${t("OBSERVATIONS")}:`}</b>
                </Typography>

                <Typography className={styles.normalText}>
                    {statusChange.statusChange.Observation}
                </Typography>
            </Box>
        </Box>)}
          
      </TimelineContent>

    </TimelineItem>)
}